import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as source from '../metric'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: source.RESOURCE.payload.dimension.partialId,
      partialId: source.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Desired goal for the metric',
    isOptional: true,
    name: 'Goal',
    partialId: PartialId.Standard.create('goal'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
